import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Marks a request whose 403 is an expected answer rather than an action a
 * supervisor could unlock. `ForbiddenInterceptor` skips the temporary-elevation
 * modal for it and lets the error reach the caller untouched.
 *
 * The interceptor assumes every 403 comes from a deliberate user action, which
 * holds for "a supervisor types the password to allow a discount". It does not
 * hold for reads gated by something elevation cannot change: signing in as
 * another user of the same tenant never puts that tenant in a live event's
 * audience, so the modal only interrupts a screen the user never acted on.
 *
 * Mark the service method, not the call site — whether elevation can help is a
 * property of the endpoint.
 *
 * @see withoutForbiddenElevation
 */
export const SKIP_FORBIDDEN_ELEVATION = new HttpContextToken<boolean>(() => false);

/**
 * Sugar to mark a request:
 *
 * ```ts
 * this.http.post<PlaybackTokenResponse>(url, null, {
 *   context: withoutForbiddenElevation(),
 *   withCredentials: true,
 * });
 * ```
 *
 * The optional argument accumulates with tokens already set on the same request
 * (`withUtcDateFields`, for example) instead of replacing them.
 */
export function withoutForbiddenElevation(
  context: HttpContext = new HttpContext(),
): HttpContext {
  return context.set(SKIP_FORBIDDEN_ELEVATION, true);
}
